<template>
  <div class="HonoraryIntroduction">
    <!-- 荣誉介绍 -->
    <div class="HonoraryIntroduction_box">
      <div class="boxContent">
        <ul
          class="item"
          v-for="(item, index) in arr"
          :key="index"
          @click="itemStyleChange(item.id)"
          :class="[itemId === item.id ? 'active' : '']"
        >
          <li class="image-container">
            <el-image :src="item.imgUrl" :preview-src-list="[item.imgUrl]" fit="cover">
            </el-image>
          </li>
          <li class="text-container" :class="[itemId === item.id ? 'active' : '']">
            {{ item.honorName }}
          </li>
        </ul>
        <el-pagination
          class="page"
          layout="prev, pager, next"
          background
          :current-page="page"
          :page-size="pageSize"
          :total="total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
import HonorIntroduction from "@/api/honorIntroduction.js";
export default {
  name: "HonoraryIntroduction",
  data() {
    return {
      itemArr: [
        {
          id: "001",
          text: "虫警监测系统V1.1"
        },
        {
          id: "002",
          text: "虫警监测系统V1.1"
        },
        {
          id: "003",
          text: "虫警监测系统V1.1"
        },
        {
          id: "004",
          text: "虫警监测系统V1.1"
        },
        {
          id: "005",
          text: "虫警监测系统V1.1"
        },
        {
          id: "006",
          text: "虫警监测系统V1.1"
        },
        {
          id: "007",
          text: "虫警监测系统V1.1"
        },
        {
          id: "008",
          text: "虫警监测系统V1.1"
        },
        {
          id: "009",
          text: "虫警监测系统V1.1"
        },
        {
          id: "0010",
          text: "虫警监测系统V1.1"
        },
        {
          id: "0011",
          text: "虫警监测系统V1.1"
        },
        {
          id: "0012",
          text: "虫警监测系统V1.1"
        }
      ],
      itemId: "001",
      arr: [],
      page: 1,
      pageSize: 10,
      total: 0
    };
  },
  methods: {
    itemStyleChange(id) {
      this.itemId = id;
    },
    async getList() {
      const params = {
        // startStatus: 1,
        honorName: "", //荣耀名称
        startTime: "",
        endTime: "",
        page: this.page,
        pageSize: this.pageSize
      };
      const { code, msg, data, total } = await HonorIntroduction.queryList(
        params
      );
      if (code === 200) {
        if (data.length > 0) {
          // 过滤enable为1的数据
          const filteredData = data.filter(item => item.enable === 1);
          if (filteredData.length > 0) {
            this.itemId = filteredData[0].id;
            this.arr = filteredData;
            this.total = total; // 更新total为过滤后的数量
          } else {
            this.arr = [];
            this.total = 0;
          }
        }
      } else {
        this.$message.error(msg);
      }
    },
    // 改变页码
    handleCurrentChange(page) {
      this.page = page;
      this.getList();
    },
    // 改变条数
    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
    }
  },
  mounted() {
    this.getList();
  }
};
</script>

<style scoped lang="scss">
.HonoraryIntroduction {
  width: 100%;
  background: url("../../../assets/img/aboutUs/ryjs_bj1.png") no-repeat;
  background-size: 100% 934px;
  .HonoraryIntroduction_box {
    width: 100%;
    height: 934px;
    display: flex;
    flex-direction: column;
    padding: 90px 360px 0;
    .boxContent {
      // flex: 1;
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      overflow: auto;
      .item {
        width: 228px;
        height: 336px;
        margin-left: 8px;
        margin-top: 28px;
        display: flex;
        flex-direction: column;
        &:hover {
          cursor: pointer;
        }
        
        .image-container {
          width: 100%;
          height: 288px;
          display: flex;
          justify-content: center;
          align-items: center;
          margin: 0;
          padding: 0;
          
          .el-image {
            width: 100%;
            height: 100%;
            
            img {
              width: 100%;
              height: 288px;
              object-fit: cover;
            }
          }
        }
        
        .text-container {
          width: 100%;
          height: 48px;
          line-height: 48px;
          text-align: center;
          background-color: #e9e9e9;
          margin: 0;
          padding: 0;
          
          &.active {
            background-color: #1c7e28 !important;
            color: #fff !important;
          }
        }
        
        &.active {
          border: 2px solid #1c7e28;
        }
      }
      .page {
        width: 100%;
        margin-top: 30px;
        display: flex;
        justify-content: center;
      }
    }
  }
}
</style>

<!-- 专门用于修改 Element UI 图片预览器样式 -->
<style lang="scss">
// 方案1: 设置预览图片的最大尺寸 (推荐)
.el-image-viewer__wrapper {
  .el-image-viewer__img {
    max-width: 80vw !important;
    max-height: 80vh !important;
    width: auto !important;
    height: auto !important;
    object-fit: contain !important;
  }
}

// 方案2: 固定预览图片尺寸
// .el-image-viewer__wrapper {
//   .el-image-viewer__img {
//     width: 500px !important;
//     height: 400px !important;
//     object-fit: cover !important;
//   }
// }

// 方案3: 自定义预览器背景和样式
// .el-image-viewer__wrapper {
//   background-color: rgba(0, 0, 0, 0.8) !important;
//   
//   .el-image-viewer__img {
//     border-radius: 8px !important;
//     box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3) !important;
//   }
// }
</style>



// WEBPACK FOOTER //
// src/views/aboutUs/honoraryIntroduction/HonoraryIntroduction.vue